/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DropoffLogistics } from './DropoffLogistics';
import {
    DropoffLogisticsFromJSON,
    DropoffLogisticsFromJSONTyped,
    DropoffLogisticsToJSON,
    DropoffLogisticsToJSONTyped,
} from './DropoffLogistics';
import type { VehicleExtra } from './VehicleExtra';
import {
    VehicleExtraFromJSON,
    VehicleExtraFromJSONTyped,
    VehicleExtraToJSON,
    VehicleExtraToJSONTyped,
} from './VehicleExtra';
import type { VehicleCharge } from './VehicleCharge';
import {
    VehicleChargeFromJSON,
    VehicleChargeFromJSONTyped,
    VehicleChargeToJSON,
    VehicleChargeToJSONTyped,
} from './VehicleCharge';
import type { VehicleRentalPeriodRules } from './VehicleRentalPeriodRules';
import {
    VehicleRentalPeriodRulesFromJSON,
    VehicleRentalPeriodRulesFromJSONTyped,
    VehicleRentalPeriodRulesToJSON,
    VehicleRentalPeriodRulesToJSONTyped,
} from './VehicleRentalPeriodRules';
import type { VehicleSummary } from './VehicleSummary';
import {
    VehicleSummaryFromJSON,
    VehicleSummaryFromJSONTyped,
    VehicleSummaryToJSON,
    VehicleSummaryToJSONTyped,
} from './VehicleSummary';
import type { PickupLogistics } from './PickupLogistics';
import {
    PickupLogisticsFromJSON,
    PickupLogisticsFromJSONTyped,
    PickupLogisticsToJSON,
    PickupLogisticsToJSONTyped,
} from './PickupLogistics';

/**
 * Vehicle details with extras, insurance options, and rules
 * @export
 * @interface VehicleDetails
 */
export interface VehicleDetails {
    /**
     * 
     * @type {VehicleSummary}
     * @memberof VehicleDetails
     */
    vehicle: VehicleSummary;
    /**
     * Available extras (insurance, equipment, etc.)
     * @type {Array<VehicleExtra>}
     * @memberof VehicleDetails
     */
    extras?: Array<VehicleExtra>;
    /**
     * Mandatory charges and surcharges
     * @type {Array<VehicleCharge>}
     * @memberof VehicleDetails
     */
    charges?: Array<VehicleCharge>;
    /**
     * Accepted payment card codes
     * @type {Array<string>}
     * @memberof VehicleDetails
     */
    acceptedPayments?: Array<string>;
    /**
     * 
     * @type {VehicleRentalPeriodRules}
     * @memberof VehicleDetails
     */
    rentalPeriodRules?: VehicleRentalPeriodRules;
    /**
     * Pickup/dropoff operation hours
     * @type {Array<string>}
     * @memberof VehicleDetails
     */
    operationHours?: Array<string>;
    /**
     * Cancellation policy text
     * @type {string}
     * @memberof VehicleDetails
     */
    cancellationPolicy?: string;
    /**
     * 
     * @type {PickupLogistics}
     * @memberof VehicleDetails
     */
    pickupLogistics?: PickupLogistics;
    /**
     * 
     * @type {DropoffLogistics}
     * @memberof VehicleDetails
     */
    dropoffLogistics?: DropoffLogistics;
}

/**
 * Check if a given object implements the VehicleDetails interface.
 */
export function instanceOfVehicleDetails(value: object): value is VehicleDetails {
    if (!('vehicle' in value) || value['vehicle'] === undefined) return false;
    return true;
}

export function VehicleDetailsFromJSON(json: any): VehicleDetails {
    return VehicleDetailsFromJSONTyped(json, false);
}

export function VehicleDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'vehicle': VehicleSummaryFromJSON(json['vehicle']),
        'extras': json['extras'] == null ? undefined : ((json['extras'] as Array<any>).map(VehicleExtraFromJSON)),
        'charges': json['charges'] == null ? undefined : ((json['charges'] as Array<any>).map(VehicleChargeFromJSON)),
        'acceptedPayments': json['accepted_payments'] == null ? undefined : json['accepted_payments'],
        'rentalPeriodRules': json['rental_period_rules'] == null ? undefined : VehicleRentalPeriodRulesFromJSON(json['rental_period_rules']),
        'operationHours': json['operation_hours'] == null ? undefined : json['operation_hours'],
        'cancellationPolicy': json['cancellation_policy'] == null ? undefined : json['cancellation_policy'],
        'pickupLogistics': json['pickup_logistics'] == null ? undefined : PickupLogisticsFromJSON(json['pickup_logistics']),
        'dropoffLogistics': json['dropoff_logistics'] == null ? undefined : DropoffLogisticsFromJSON(json['dropoff_logistics']),
    };
}

export function VehicleDetailsToJSON(json: any): VehicleDetails {
    return VehicleDetailsToJSONTyped(json, false);
}

export function VehicleDetailsToJSONTyped(value?: VehicleDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vehicle': VehicleSummaryToJSON(value['vehicle']),
        'extras': value['extras'] == null ? undefined : ((value['extras'] as Array<any>).map(VehicleExtraToJSON)),
        'charges': value['charges'] == null ? undefined : ((value['charges'] as Array<any>).map(VehicleChargeToJSON)),
        'accepted_payments': value['acceptedPayments'],
        'rental_period_rules': VehicleRentalPeriodRulesToJSON(value['rentalPeriodRules']),
        'operation_hours': value['operationHours'],
        'cancellation_policy': value['cancellationPolicy'],
        'pickup_logistics': PickupLogisticsToJSON(value['pickupLogistics']),
        'dropoff_logistics': DropoffLogisticsToJSON(value['dropoffLogistics']),
    };
}

